// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0x9wr","content":"styles_content__Vq8av","title":"styles_title__s9t9p"};